<!-- <div class="modal-header">
    <h5 id="mediaTestTitle" class="modal-title text-center">Proctor dual angle setup</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancelModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div> -->
<div class="modal-body" style="max-height: 90vh; overflow: auto; position: relative">
    <button type="button" class="close" aria-label="Close" (click)="cancelModal()">
        <span aria-hidden="true" class="text-danger">&times;</span>
    </button>
    <div>
        <!-- <video id="x" autoplay playslinline></video> -->
        <!-- <h6>Instructions</h6> -->
        <!-- <div>{{this.instructionsText}}</div> -->
        <div><b>You are required to use your mobile device {{this.allowExternalSecondViewCamera ? "or an external webcam" : ""}} to provide a second angle for proctoring</b></div>
        <div>
            <ul id="instructions-list">
                <li *ngIf="this.allowExternalSecondViewCamera">If using an external webcam, the cable must be long enough to provide adequate view of your screen and the space around your screen as shown below</li>
                <li>The second camera or mobile device must be positioned so that it shows <b>your side view</b> and <b>your screen</b> (along with the <b>spaces beside your screen</b>)</li>
                <li>To prevent disconnection, ensure your mobile device is on <b>Do Not Disturb</b> mode and has <b>sufficient charge or is plugged</b> in before proceeding</li>
                <li>You will need to <b>grant all permissions requested</b> on your mobile device</li>
            </ul>
            <div><b>For guidance, see the image below</b></div>
        </div>
        <div id="sample-setup-div" class="text-center">
            <div><b>Correct Sample setup</b></div>
            <img src="/assets/sample_dual_view_setup.jpg">
        </div>
        <div [hidden]="!(this.externalSecondViewCameraChosen || (this.mobileSecondViewCameraChosen && this.gotInteractiveSecondViewImageSnapshot))" id="webcam-previews-div" class="text-center">
            <div><b>Ensure you are CLEARLY VISIBLE and your cameras are PLACED CORRECTLY before you proceed</b></div>
            <video autoplay playsinline #mainVideo id="main-camera-video"></video>
            <video *ngIf="this.externalSecondViewCameraChosen else interactiveSecondViewDisplay" autoplay playsinline #secondViewVideo id="second-view-camera-video"></video>
            <ng-template #interactiveSecondViewDisplay>
                <img [hidden]="this.interactiveSecondViewVideoPlaying" #interactiveSecondViewCameraImage id="interactive-second-view-camera-image" [src]="this.interactiveSecondViewImageSnapshotObjectUrl">
                <video [hidden]="!this.interactiveSecondViewVideoPlaying" autoplay playsinline #secondViewVideo id="second-view-mobile-video"></video>
            </ng-template>
        </div>
    </div>
    <div id="preference-question-div" *ngIf="this.showPreferenceQuestion">
        <div id="preference-radio-button-options">
            <h6 class="text-center">Select an option to continue</h6>
            <div><input [disabled]="!this.hasSecondViewCamera" type="radio" id="external-webcam-radio-button" value="webcam" name="second-view-preference" [(ngModel)]="this.secondViewPreference"><label for="external-webcam-radio-button">External Webcam - {{(this.hasSecondViewCamera ? this.secondViewDeviceLabel : 'Not found/Not supported')}}</label></div>
            <div><input type="radio" id="external-device-radio-button" value="mobile" name="second-view-preference" [(ngModel)]="this.secondViewPreference"><label for="external-device-radio-button">Mobile device</label></div>
        </div>
        <div class="text-center">
            <button (click)="this.proceedWithSecondViewPreferenceChoice(false)" class="btn btn-success" [disabled]="!this.secondViewPreference">Continue</button>
        </div>
    </div>
    <div id="accessCodeDiv" *ngIf="this.showAccessCodeDiv else externalSecondViewContinueButton">
        <div *ngIf="this.secondViewAccessCode else loading">
            <div id="qrcode-div" class="text-center">
                <div><span><b>Open the camera app on your mobile device and scan the QR code below to proceed</b></span></div>
                <div><b>Note:</b> If you are having problems using the QR code, please see alternative steps below</div>
                <qrcode
                    [qrdata]="this.qrCodeUrl"
                    [allowEmptyString]="true"
                    [cssClass]="'center'"
                    [colorDark]="'#000000ff'"
                    [colorLight]="'#ffffffff'"
                    [elementType]="'canvas'"
                    [errorCorrectionLevel]="'M'"
                    [imageSrc]="'https://cbt.webtest.ng/assets/images/favicon_96.png'"
                    [imageWidth]="20"
                    [imageHeight]="20"
                    [margin]="4"
                    [scale]="1"
                    [width]="200"></qrcode>
                <!-- <qrcode [qrdata]="this.qrCodeUrl" [size]="256" [level]="'M'"></qrcode> -->
            </div>
            <div class="text-center mt-1">Please wait. Waiting for connection from your mobile device...</div>
            <div class="text-center"><app-loading-spinner></app-loading-spinner></div>
            <div><b>Alternative Steps:</b></div>
            <div class="">If you are having problems using the QR code, follow the steps below to proceed:</div>
            <ol id="alternative-steps-list">
                <li>Install Google Chrome on your mobile device (If already installed, ensure it is up to date)</li>
                <li>Open Google Chrome</li>
                <li>Navigate to <b class="text-info">{{this.secondViewExternalDeviceUrl}}</b></li>
                <li>Grant all permissions requested</li>
                <li>Place your phone in landscape mode</li>
                <li>
                    <span>Enter the details below to proceed:</span>
                    <ul>
                        <li><h6 class="mb-0">Candidate Number: <b>{{this.candidateNo}}</b></h6></li>
                        <li><h6 class="mb-0">Access Code: <b>{{this.secondViewAccessCode}}</b></h6></li>
                    </ul>
                </li>
            </ol>
        </div>
        <ng-template #loading>
            <div class="text-center"><app-loading-spinner></app-loading-spinner></div>
        </ng-template>
    </div>
    <div *ngIf="this.waitingForSecondView">
        <div *ngIf="this.secondViewPreference == 'webcam' else connectingExternalDeviceMessageDiv" class="text-center">Connecting {{this.secondViewDeviceLabel}}...</div>
        <div class="text-center"><app-loading-spinner></app-loading-spinner></div>
        <ng-template #connectingExternalDeviceMessageDiv><div class="text-center">Connecting your mobile device...</div></ng-template>
    </div>
    <ng-template #externalSecondViewContinueButton>
        <div *ngIf="!this.showPreferenceQuestion && !this.waitingForSecondView && !this.runningInitialSetup" class="text-center"><button class="btn btn-success" (click)="this.proceedWithSecondViewPreferenceChoice(true)">Proceed</button></div>
    </ng-template>
</div>
